import { useTranslation } from "react-i18next";
import { IconFire, IconGift, IconUserImages, IconUserChristmasImages } from "../elements/Icon";
import { IconMedal } from "../elements/Icon2";
import { checkChristmas } from "../../hooks/useCheckChristmas";
import { isDev, isProd } from "../../config";

export const UserModalPage = ({ userModal, setUserModal }) => {
    const { t } = useTranslation();
    const basePath = isDev
        ? "https://sandbox.mathmindsgame.com:3080"
        : isProd
            ? "https://mathmindsgame.com:3080"
            : "http://127.0.0.1:3000";

    const formatDate = (timestamp) => {
        if (!timestamp) return "-";
        const d = new Date(timestamp * 1000);
        let date = d.toLocaleDateString("en-GB");
        return date.replaceAll("/", ".")
    };
    const lang = localStorage.getItem('i18nextLng') || 'en'
    const regionNames = new Intl.DisplayNames([lang], { type: 'region' });

    return (
        <div
            onClick={() => setUserModal(null)}
            className="absolute inset-0 z-[100000] bg-black/30 flex justify-center items-center"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{ backgroundImage: "url('/backGrounds/userModal.svg')" }}
                className="
                    relative
                    w-[318px] md:w-[372px] xl:w-[450px] lg:w-[427px]
                    w-[194px] md:h-[259px] xl:h-[335px] lg:h-[297px]
                    rounded-[20px]
                    border-[4px] border-[#7B4BC4]
                    bg-cover bg-center
                    p-5
                    "
            >
                {/* TOP */}
                <div className="flex items-center justify-between">

                    {/* LEFT */}
                    <div className="flex items-center gap-4">

                        {/* avatar */}
                        <div
                            className="
                                        flex-shrink-0
                                        xl:w-[127px] lg:w-[90px] md:w-[78px] sm:w-[64px] w-[64px]
                                        xl:h-[127px] lg:h-[90px] md:h-[78px] sm:h-[64px] h-[64px]
                                        rounded-full overflow-hidden
                                        bg-[#ACC587] border border-[#7743BA]
                                        flex items-center justify-center"
                        >
                            {checkChristmas() ? (
                                <IconUserChristmasImages user={userModal.avatar} />
                            ) : (
                                <IconUserImages user={userModal.avatar} />
                            )}
                        </div>

                        {/* nickname + country */}
                        <div className="flex flex-col">

                            <p className="xl:text-[24px] lg:text-[20px] md:text-[16px] text-[16px] text-[#4B96C9] font-bold">
                                {userModal?.nickname}
                            </p>

                            <div className="flex items-center gap-2">

                                <div
                                    className="
                                                xl:w-[18px] lg:w-[18px] md:w-[21px] w-[18px]
                                                xl:h-[12px] lg:h-[12px] md:h-[14px] h-[12px]
                                                border bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url(${basePath}/images/flags/${userModal?.cc}.svg)`
                                    }}
                                />

                                <span className="xl:text-[12px] lg:text-[12px] md:text-[12px] text-[10px] truncate">
                                    {regionNames.of(userModal?.cc || "AM")}
                                </span>

                            </div>

                        </div>

                    </div>

                    {/* RIGHT */}
                    <div className="flex flex-col items-center">

                        <IconMedal className="
                        xl:w-[38px] lg:w-[33.78px] md:w-[29.56px] w-[25.33px]
                        xl:w-[43.67px] lg:w-[38.82px] md:w-[33.97px] w-[29.12px]" />

                        <p className={`${userModal?.place <= 3 ? "relative xl:-top-[44px] lg:-top-[37px] md:-top-[34px] -top-[31px] text-[#FFF]" : "text-[#4B96C9]"} xl:text-[20px] lg:text-[16px] md:text-[16px] text-[16px]  font-bold`}>
                            {userModal?.place}
                        </p>

                    </div>

                </div>




                {/* divider */}
                <div className="border-t border-[#ACC587] my-4"></div>

                {/* stats */}
                <table className="w-full xl:text-[20px] lg:text-[16px] md:text-[14px] text-[12px] border-collapse font-bold ">
                    <tbody>

                        <tr>
                            <td className="pr-10 text-[#7B4BC4] text-right">Today</td>

                            <td className="text-left text-[#4B96C9] border-r border-[#F3F4D1] pr-3">
                                {userModal?.dailyPoints}
                            </td>

                            <td className="text-right text-[#4B96C9]">
                                <div className="flex items-center justify-end gap-1">
                                    <IconFire className="w-[20px]" />
                                    <span>{userModal?.strike}</span>
                                </div>
                            </td>

                            <td className="text-right text-[#4B96C9]">
                                <div className="flex items-center justify-end gap-1">
                                    <IconGift className="w-[20px]" />
                                    <span>{userModal?.gift}</span>
                                </div>
                            </td>
                        </tr>

                        {/* line */}
                        <tr>
                            <td colSpan={2}>
                                <div className="border-b border-[#F3F4D1] w-[95%]"></div>
                            </td>

                            <td colSpan={2}>
                                <div className="border-b border-[#F3F4D1]"></div>
                            </td>
                        </tr>

                        <tr>
                            <td className="pr-10 text-[#7B4BC4] text-right ">All</td>

                            <td className="text-left text-[#4B96C9] border-r border-[#F3F4D1] pr-3">
                                {userModal?.totalPoints}
                            </td>

                            <td colSpan={2}></td>
                        </tr>

                        <tr>
                            <td colSpan={2}>
                                <div className="border-b border-[#F3F4D1] mt-2 w-[95%]"></div>
                            </td>

                            <td colSpan={2}></td>
                        </tr>

                        <tr>
                            <td className="pr-10 text-[#7B4BC4] text-right">Last Active</td>
                            <td className="text-left text-[#4B96C9]">
                                {formatDate(userModal?.active)}
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
};